import { jdiColorFetch } from '@/apis/colorFetchV2';
import type { SlotListReq, RecommendDataReq } from './recommend.interface';
import { getEdiTokenFromCookie } from '@/utils/fingerprint';

// 获取推荐tab列表
export const queryRecommendationGetSlotList = async (params: SlotListReq) => {
  return await jdiColorFetch('guide_recommendation_getSlotList', {
    bodyQuery: {
      ...params,
    },
    method: 'post',
    params: {
      uuid: getEdiTokenFromCookie(),
    },
  });
};

//获取推荐数据
export const queryProductRecommendData = async (params: RecommendDataReq) => {
  const res = await jdiColorFetch(
    `guide_recommendation_get`,
    // cache保存时间5秒
    {
      bodyQuery: {
        ...params,
      },
      next: { revalidate: 5 },
      method: 'post',
      params: {
        uuid: getEdiTokenFromCookie(),
      },
    },
  );
  if (res.error) {
    throw new Error(res.error);
  }
  return res;
};
